import {
  CustomerMessageIdEnum,
  useGetLastKnownSmtpCredentialsQuery,
  useListEmailCredentialsQuery,
} from '@dms/api/core';

import {getMailboxOptionsByOwner} from '../utils/getMailboxOptionsByOwner';
import {resolveDefaultMailboxId} from '../utils/resolveDefaultMailboxId';

export const useSmtpOptions = (
  customerMessageId: CustomerMessageIdEnum,
  preferredAddresses: string[] = []
) => {
  const {data: userSmtpCredentials, isLoading: isLoadingUserSmtpCredentials} =
    useListEmailCredentialsQuery({});

  const {data: lastKnownSmtpCredentials, isLoading: isLoadingLastKnownSmtpCredentials} =
    useGetLastKnownSmtpCredentialsQuery({customerMessageId});

  const smtpCredentials = userSmtpCredentials?.credentials ?? [];

  const defaultSmtpCredentialId = resolveDefaultMailboxId(
    smtpCredentials,
    lastKnownSmtpCredentials?.smtpCredentialsId,
    preferredAddresses
  );

  const smtpCredentialsOptions = getMailboxOptionsByOwner(smtpCredentials);

  const isLoading = isLoadingUserSmtpCredentials || isLoadingLastKnownSmtpCredentials;

  return {
    defaultSmtpCredentialId,
    smtpCredentialsOptions,
    isLoading,
  };
};
